import { Directive, inject, input } from '@angular/core'
import { SidebarService } from './sidebar.service'

@Directive({
    selector: '[sqSidebarToggle]',
    exportAs: 'sqSidebarToggle',
    host: {
        '(click)': 'toggleOpen($event)',
    },
})
export class SidebarToggleDirective {
    readonly #sidebarService = inject(SidebarService)

    /**
     * Id of sidebar for toggle action.
     * @return string
     */
    readonly id = input<string>(undefined, { alias: 'sqSidebarToggle' })
    /**
     * Sidebar property name for toggle action.
     *
     * @return 'visible' | 'unfoldable'
     * @default 'visible'
     */
    readonly toggle = input<'visible' | 'unfoldable'>('visible')

    toggleOpen($event: any): void {
        $event.preventDefault()
        this.#sidebarService.toggle({ toggle: this.toggle(), id: this.id() })
    }
}
